import loading from 'assets/pictures/loading.gif'
import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getUserBookmarksByStationType } from '../../utils/UserUtil'
import { componentHasHabilitations } from '../../utils/HabilitationUtil'
import { H_AGRI_MODULE } from '../../account/constants/AccessRulesConstants'
import UserThunk from 'administration/components/user/actions/UserThunk'
import useStateProgress from 'utils/customHook/useStateProgress'
import AgriThunk from 'agriAdministration/actions/AgriThunk'
import CurrentSurveysPanel from 'survey/components/panels/CurrentSurveysPanel'
import { NewTable } from 'components/datatable/NewTable'
import { Card, CardContent, Grid, Icon, Stack } from '@mui/material'
import ProgressBar from 'components/progress/ProgressBar'
import LocalFloristIcon from '@mui/icons-material/LocalFlorist'
import { darkBlue } from '../../utils/constants/ColorTheme'
import { CardTitle } from '../../components/card/NewCard'

const AgriCard = () => {
    const {
        userBookmarks,
        exploitationsLight,
        userBookmarksStatus,
        exploitationsLightStatus,
    } = useSelector(store => ({
        userBookmarks: store.UserReducer.userBookmarks,
        exploitationsLight: store.AgriReducer.exploitationsLight,
        userBookmarksStatus: store.DataManagerReducer.user.userBookmarksStatus,
        exploitationsLightStatus: store.DataManagerReducer.agri.exploitationsLightStatus,
    }), shallowEqual)

    const { progress: progressBar, isLoaded: dataLoaded } = useStateProgress([userBookmarksStatus, exploitationsLightStatus])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(UserThunk.fetchBookmarks())
        dispatch(AgriThunk.fetchExploitationsLight())
    }, [])

    const bookmarks = useMemo(() => getUserBookmarksByStationType(userBookmarks, 'agriculture'), [userBookmarks])

    const data = useMemo(() => ({
        exploitations: exploitationsLight,
        bookmarks,
        habilitation: componentHasHabilitations(H_AGRI_MODULE),
    }), [bookmarks, exploitationsLight])

    const redirect = (href = '') => dispatch(push(href))

    if (dataLoaded) {
        if (!(data.habilitation && (data.bookmarks.length > 0 || data?.exploitations?.length > 0))) {
            return null
        }
        const exploitations = exploitationsLight.filter((e) => data.bookmarks.includes(String(e.idExploitation)))
        return (
            <Card>
                <CardTitle
                    title={i18n.agriculture}
                    icon={<LocalFloristIcon fontSize={'large'} />}
                    color={darkBlue}
                />
                <Grid container spacing={1}>
                    <Stack sx={{ width: '100%' }}>
                        <CurrentSurveysPanel />
                        {exploitations?.length ? (
                            <NewTable
                                rows={exploitations}
                                headers={[
                                    { key: 'icon', value: <Icon>folder</Icon>, tooltip: i18n.exploitations, onClick: () => redirect('/dossiers') },
                                    'codification',
                                    'name',
                                    'inseeCode',
                                    'city',
                                    'address',
                                ]}
                                onClickRow={(e) => redirect(`/dossiers/${e.idExploitation}/dashboard`)}
                            />
                        ) : ''}
                    </Stack>
                </Grid>
            </Card>
        )
    }
    return (
        <Card>
            <CardContent>
                <Grid
                    container
                    justifyContent='center'
                    alignItems='center'
                    direction='column'
                    sx={{ pt: 2.5 }}
                >
                    <img src={loading} />
                    <Grid size={3}>
                        <ProgressBar
                            withMessage
                            message={i18n.agriCardInProgress}
                            progress={progressBar}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default AgriCard